module.exports = __webpack_public_path__ + "static/media/Mohammad Adriani.a97e2d8a.png";